import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { initLenis, scrollTop } from "@/lib/lenis";
import { PromoBar } from "@/components/PromoBar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import TreatmentPage from "@/pages/TreatmentPage";
import ProductPage from "@/pages/ProductPage";
import ScrubPage from "@/pages/ScrubPage";
import KitPage from "@/pages/KitPage";
import QuizPage from "@/pages/QuizPage";
import ReviewsPage from "@/pages/ReviewsPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminMessages from "@/pages/AdminMessages";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      scrollTop();
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollManager />
        <PromoBar />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/prodotto/trattamento-rapida-crescita" element={<TreatmentPage />} />
          <Route path="/prodotto/:slug" element={<ProductPage />} />
          <Route path="/scrub" element={<ScrubPage />} />
          <Route path="/kit" element={<KitPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/recensioni" element={<ReviewsPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contatti" element={<ContactPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminMessages />} />
        </Routes>
        <Footer />
        <CartDrawer />
        <Toaster position="bottom-center" richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
